import { useMutation } from '@tanstack/react-query'
import * as scansAPI from '@/api/scansAPI'

export function useRunScan() {
  return useMutation({
    mutationFn: ({
      token,
      fundingNeedId,
      includeRelational,
      includeFuturePlanning,
      isOnboarding,
    }: {
      token: string
      fundingNeedId: number
      includeRelational: boolean
      includeFuturePlanning?: boolean
      isOnboarding?: boolean
    }) =>
      scansAPI.runScan(
        token,
        fundingNeedId,
        includeRelational,
        includeFuturePlanning ?? false,
        isOnboarding ?? false
      ),
  })
}
